import PropTypes from 'prop-types'
import { useRef } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { ChartContainer } from '../../../../../../common/chart/chartContainer'
import Area from '../../../../../../common/chart/chartContainer/Area'
import Line from '../../../../../../common/chart/chartContainer/Line'
import { Element } from '../../../../../../common/html/element'
import { getUnique } from '../../../../../../helpers/common'
import { valToPercent } from '../../../../../../helpers/value'

const Chart = ({ data, chartParam, isDynamicReport }) => {
  const chartId = useRef(getUnique())

  const locale = useSelector((state) => state.i18n.locale)

  return (
    <>
      <div className="h100 w65">
        <ChartContainer
          chartId={chartId.current}
          data={data}
          margin={{ top: 20, left: 8, bottom: 0, right: 8 }}
          width="100%"
          height="100%"
          xAxis={[
            {
              dataKey: 'year',
              padding: { left: 18, right: 18 },
              tickMargin: 3,
              height: 18,
            },
          ]}
          yAxis={[
            {
              yAxisId: 'left',
              dataKeys: [chartParam.line.value, chartParam.area.value],
              isLineChart: true,
              hide: true,
            },
          ]}
          tooltip={{
            schema: {
              content: [
                {
                  dataKey: chartParam.line.value,
                  label: chartParam.line.title,
                  formatValue: (val) => valToPercent(val, locale, true),
                },
                {
                  dataKey: chartParam.area.value,
                  label: chartParam.area.title,
                  formatValue: (val) => valToPercent(val, locale, true),
                },
              ],
            },
          }}
        >
          <Area
            yAxisId="left"
            dataKey={chartParam.area.value}
            fill={chartParam.area.color}
            dot={{ fill: chartParam.area.dotColor }}
          />
          <Line
            yAxisId="left"
            dataKey={chartParam.line.value}
            stroke={chartParam.line.color}
            dot={{ r: 4, troke: 'none', strokeWidth: 0 }}
            label={(props) => {
              const { x, y, value } = props
              return (
                <g>
                  <foreignObject x={x - 25} y={y - 20} height={18} width={50}>
                    <Element
                      className="h100 w100 textCenter fw400"
                      style={{ fontSize: 10 }}
                    >
                      {valToPercent(value, locale, true)}
                    </Element>
                  </foreignObject>
                </g>
              )
            }}
          />
        </ChartContainer>
      </div>
      <div className="h100 w35 dFlex alignItemsCenter justifyContentCenter">
        <div>
          <Element style={{ color: chartParam.line.color }}>
            <Translate value="financialAnalysis.COMPANY" />
          </Element>
          <Element className="mt2" style={{ color: chartParam.area.color }}>
            <Translate value="financialAnalysis.INDUSTRY_AVG" />
          </Element>
        </div>
      </div>
    </>
  )
}

Chart.propTypes = {
  data: PropTypes.array.isRequired,
  chartParam: PropTypes.object.isRequired,
}

export default Chart
